import { Dtos, SuretyAccountId, SuretyAccountUnderwritingId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import {
	accountBondingLineQueryKey,
	accountLatestUnderwritingQueryKey,
	accountQueryKey,
} from "../account.keys";

export const useAdminUpdateSuretyAccountStatus = (
	accountId: SuretyAccountId,
	underwritingId: SuretyAccountUnderwritingId,
) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		mutationKey: ["updateSuretyAccountStatus", accountId, underwritingId],
		mutationFn: async (data: Dtos.Admin.SuretyAccount.Update.Underwriting.Status.Request) => {
			await patch(
				`/v2/admin/surety/accounts/${accountId}/underwritings/${underwritingId}`,
				data,
				"none",
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountBondingLineQueryKey(accountId) }),
				queryClient.invalidateQueries({
					queryKey: accountLatestUnderwritingQueryKey(accountId),
				}),
				queryClient.refetchQueries({ queryKey: accountPreviewsQueryKey() }),
				queryClient.refetchQueries({ queryKey: bondRequestPreviewsQueryKey() }),
			]);
		},
	});

	return {
		updateSuretyAccountStatus: mutation.mutate,
		updateSuretyAccountStatusIsLoading: mutation.isPending,
	};
};
